import { configureStore } from '@reduxjs/toolkit';
import {
    TypedUseSelectorHook,
    useDispatch as dispatchHook,
    useSelector as selectorHook,
} from 'react-redux';
import type {} from 'redux-thunk/extend-redux';
import { AppDispatch } from '../utils/store-types';
import { rootReducer, RootState } from './reducers';
import { socketMiddleware } from './middleware/socketMiddleware';
import {
    connect as SocketConnect,
    disconnect as SocketDisconnect,
    wsConnecting as SocketConnecting,
    wsOpen as SocketOpen,
    wsClose as SocketClose,
    wsMessage as SocketMessage,
    wsError as SocketError,
} from './wsAll/actions';
import {
    connect as SocketUserConnect,
    disconnect as SocketUserDisconnect,
    wsConnecting as SocketUserConnecting,
    wsOpen as SocketUserOpen,
    wsClose as SocketUserClose,
    wsMessage as SocketUserMessage,
    wsError as SocketUserError,
} from './wsUser/actions';

const wsMiddleware = socketMiddleware({
    wsConnect: SocketConnect,
    wsDisconnect: SocketDisconnect,
    wsConnecting: SocketConnecting,
    onOpen: SocketOpen,
    onClose: SocketClose,
    onMessage: SocketMessage,
    onError: SocketError,
});

const wsUserMiddleware = socketMiddleware({
    wsConnect: SocketUserConnect,
    wsDisconnect: SocketUserDisconnect,
    wsConnecting: SocketUserConnecting,
    onOpen: SocketUserOpen,
    onClose: SocketUserClose,
    onMessage: SocketUserMessage,
    onError: SocketUserError,
});

export type { RootState } from './reducers';
export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware().concat(wsMiddleware, wsUserMiddleware),
});
// export type AppDispatch = typeof store.dispatch;

export const useDispatch: () => AppDispatch = dispatchHook;
export const useSelector: TypedUseSelectorHook<RootState> = selectorHook;
// export const useAppDispatch = () => useDispatch<AppDispatch>();
// export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
